import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { formatMoney } from '../utils/utils.js'
require(`../assets/${process.env.PAGE}/css/product-option.css`);
import { ReactGA }  from './App';

class ProductOption extends Component {

    constructor(props) {
        super(props);
        this.state = { 
            productSelected: false
        };

        this.selectProduct = this.selectProduct.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const { quotaOption, amountOption } = this.props;
        if(quotaOption === nextProps.currentQuota && amountOption === nextProps.currentAmount){
            this.setState({
                productSelected: true
            });
        }else{
            this.setState({
                productSelected: false
            });
        }
    }

    trackGAEvent() {
        let gaEvent = {}
        if(this.props.gaCategory) gaEvent.category = this.props.gaCategory;
        if(this.props.gaAction) gaEvent.action = this.props.gaAction;
        if(this.props.gaValue) gaEvent.value = parseInt(this.props.gaValue, 10);
        if(this.props.gaLabel) gaEvent.label = this.props.gaLabel;
        ReactGA.event(gaEvent);
    }

    selectProduct() {

        this.props.onClick(this.props.quotaOption.toString(), this.props.amountOption);
        this.setState({
            productSelected: true
        });
        this.trackGAEvent()
    }

    render() {
        const { quotaOption, amountOption } = this.props;
        return (
            <div className="product-option">
                <p>
                <span className="amount">{formatMoney(amountOption, 0, ',', '.')}</span>
                <span className="quotas">{quotaOption.toString() + ' cuotas' }</span>
                </p>
                <Button
                    className="btn btn-warning btn-sm pd-simple-button pd-choise-button"
                    onClick={this.selectProduct} 
                    disabled={ this.state.productSelected }>
                        Elegir
                </Button>
            </div>
        );
    }
}


export default ProductOption;


/** WEBPACK FOOTER **
 ** ./src/components/ProductOption.js
 **/